import styled from 'styled-components';

export const LegendContainer = styled.div`
  display: flex;
  justify-content: space-around;
  
  & > div.contentBox {
    display: flex;
    flex-direction: column;
    flex: 1;
    background: #2F3B49;
    padding: .2rem;
    margin: 5px;
    font-size: 19px;
    color: #fff;

    & > div.title {
      background: #5b2f2f;
      border-radius: 4px;
      font-size: 15px;
      color: #fff;
    }

    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
      padding: .25rem;
      font-size: 15px;
      color: #fff;
    }
  }
`;